module.exports = __webpack_public_path__ + "nc_static/media/logo_merck_loader.1e765d9e.svg";